module.exports = __webpack_public_path__ + "img/complete-wo-button.f65f9a14.svg";